import {OperationId} from '@iiiristram/sagun'

export * from './decorators'
export * from './modal'
export * from './selectors'
export * from './strategies'

export const OperationID = <T>(id: string): OperationId<T> => {
  return `operation/${id}` as OperationId<T>
}
